import { Container } from "inversify";

const container = new Container();


export const adminModule = {
    module: container,
};
